export const falsy = (): boolean => false;
